// extracted by mini-css-extract-plugin
export default {"DeleteUserPermissionDialog":"DeleteUserPermissionDialog_DeleteUserPermissionDialog__rjDnt"};